import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Экран отказа в доступе — с выходом, а не белым листом (`s014`, 10.09.2026).
 *
 * ⛔ Оба отказа — «раздел спрятан» (`RequireVidimost`) и «раздел не открыт»
 * (`RequirePermission`) — рисовались объяснением посреди пустой страницы: ни
 * меню, ни ссылки. Человек, набравший адрес руками, понимал, ЧТО произошло, и
 * не понимал, куда теперь идти. Объяснить отказ и запереть в нём — не одно и
 * то же.
 *
 * ⛔ Каркасом (`AppShell`) экран не оборачивается намеренно: каркас тянет за
 * собой филиалы и запросы к серверу — на экране, который человеку показывают
 * ВМЕСТО раздела, это лишняя работа и лишние отказы. Достаточно двери наружу.
 */
export function OtkazVDostupe({
  zagolovok,
  kuda,
  children,
}: {
  zagolovok: string;
  /** Куда увести человека по его слову: первый доступный ему раздел. */
  kuda: string | null;
  children: ReactNode;
}) {
  return (
    <div className="ops-skin flex min-h-[60vh] items-center justify-center p-6">
      <div className="max-w-md rounded-ops-card border border-ops-border bg-ops-surface p-8 text-center shadow-ops-card">
        <div className="text-ops-h2 font-bold text-ops-text">{zagolovok}</div>
        <p className="mt-3 text-sm leading-relaxed text-ops-text-secondary">{children}</p>
        {kuda && (
          <Link
            to={kuda}
            className="mt-6 inline-block rounded-ops-control bg-ops-primary px-4 py-2 text-sm font-semibold text-white"
          >
            Вернуться к своим разделам
          </Link>
        )}
      </div>
    </div>
  );
}
